module.exports = __webpack_public_path__ + "static/media/estig.403027f9.png";